import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { RestUseCase } from 'service/api/rest/rest-usecase';
import { getEnv } from 'helper/window-helper';
import { SelectOptionInterface } from '../../@types/entity/interface/select-option-interface';
import { Col, Row, Button } from 'react-bootstrap';

interface Props {
    onCompanyChange: (companyId: string | null) => void;
    onNewButtonClick: () => void;
}

const SelectCompany: React.FC<Props> = ({ onCompanyChange, onNewButtonClick }) => {
    const ENDPOINT_COMPANIES = getEnv('REACT_APP_END_POINT_COMPANIES')!;

    const [companyOptions, setCompanyOptions] = useState<SelectOptionInterface[]>([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState<string | undefined>(undefined);

    async function fetchCompanies() {
        try {
            const response = await new RestUseCase(ENDPOINT_COMPANIES).Get();
            if (response.statusCode !== 500 && response.statusCode !== undefined) {
                const companies = response.body.map((value: any) => ({
                    value: value.id.toString(),
                    label: value.nome,
                }));
                setCompanyOptions(companies);
            }
        } catch (error) {
            console.error('Erro ao buscar as empresas:', error);
        }
    }

    useEffect(() => {
        fetchCompanies();
    }, []);

    const handleCompanyChange = (selectedOption: SelectOptionInterface | undefined) => {
        const companyId = selectedOption ? selectedOption.value : undefined;
        setSelectedCompanyId(companyId);
        onCompanyChange(companyId);
    };

    return (
        <div>
            <Row className="mt-3">
                <Col>Empresa:</Col>
            </Row>
            <Row className="mt-3">
                <Col xs="4">
                    <Select
                        options={companyOptions}
                        onChange={(company) => company && handleCompanyChange(company)}
                        placeholder="Selecione uma empresa"
                        isSearchable
                    />
                </Col>
                <Col xs="4">
                    <Button
                        variant="primary"
                        onClick={onNewButtonClick}
                    >
                        Novo
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default SelectCompany; 